export default "__VITE_ASSET__D6c2rP8h__"